'use client'

import { useAuth } from '@clerk/nextjs'
import { useEffect } from 'react'
import { useUserPermissions } from '@/hooks/useUserPermissions'

const STORAGE_KEY = 'zebra-theme'

function setLight() {
  document.documentElement.setAttribute('data-theme', 'light')
}

/**
 * Tryb ciemny tylko dla admina (przełącznik + localStorage).
 * Dla pozostałych zawsze jasny motyw — czyści zapisaną preferencję.
 */
export function ZebraThemeAdminSync() {
  const { isLoaded, userId } = useAuth()
  const { isLoading, userRoles } = useUserPermissions()

  useEffect(() => {
    if (!isLoaded) return

    if (!userId) {
      setLight()
      try {
        localStorage.removeItem(STORAGE_KEY)
      } catch {
        /* ignore */
      }
      window.dispatchEvent(new Event('zebra-theme'))
      return
    }

    if (isLoading) return

    const isAdmin = userRoles?.includes('admin')

    if (!isAdmin) {
      setLight()
      try {
        localStorage.removeItem(STORAGE_KEY)
      } catch {
        /* ignore */
      }
      window.dispatchEvent(new Event('zebra-theme'))
      return
    }

    try {
      const t = localStorage.getItem(STORAGE_KEY)
      if (t === 'dark' || t === 'light') {
        document.documentElement.setAttribute('data-theme', t)
      } else {
        setLight()
      }
    } catch {
      setLight()
    }
    window.dispatchEvent(new Event('zebra-theme'))
  }, [isLoaded, userId, isLoading, userRoles])

  return null
}
